var map = {
	"./account-manager-12-facts-without-a-spreadsheet.md": 771,
	"./csm-vs-am-who-owns-the-money.md": 712,
	"./discount-leakage-list-to-invoice.md": 735,
	"./order-form-is-the-contract-finance-reads.md": 474,
	"./post-sale-journey-as-revenue-moments.md": 625,
	"./renewal-price-increase-without-a-fight.md": 417,
	"./where-the-farming-week-goes.md": 616,
	"./whitespace-is-a-data-problem-first.md": 34,
	"./why-expansion-is-the-growth-engine-nobody-staffs.md": 388,
	"./your-discount-approval-policy-is-a-suggestion.md": 324
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 953;